import { backgroundPrimary } from "../styles/graph-colors"
// Colors Layers
export const COLOR_STAGE = 'none'
export const COLOR_CONTRACT_LAYER = backgroundPrimary
export const COLOR_SUBCONTRACT_LAYER =backgroundPrimary
export const COLOR_TASK_LAYER = backgroundPrimary

//
export const GAP_BW_LAYERS = 0.1
export const GAP_BW_ROWS = 0.5
export const TOP_MARGIN_LAYER = 0.1
export const BOTTOM_MARGIN_LAYER = 0.1
export const LEFT_MARGIN_LAYER = 10
